import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { COMPACT_MOBILE_BREAKPOINT } from "@ryde/theme";

export const LiveMapMobileGridStatusPanelStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "live-map-mobile-grid-status-panel",
  },
)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;

  .live-map-grid-status-breakdown-row--mobile-strip {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    flex: 0 1 auto;
    min-width: 0;
    max-width: 100%;
    flex-wrap: nowrap;
    overflow: hidden;
    gap: 3px;
  }

  .live-map-grid-status-breakdown--mobile-strip {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    flex: 0 1 auto;
    min-width: 0;
    max-width: 100%;
    flex-wrap: nowrap;
    overflow: hidden;
    gap: 3px;
  }

  .live-map-grid-status-chip-tooltip-trigger {
    flex: 0 1 auto;
    min-width: 0;
    max-width: 100%;
    display: inline-flex;
  }

  [data-e2e="live-map-grid-status-chip"],
  [data-e2e="live-map-planned-for-now-chip"] {
    width: auto;
    max-width: 100%;
    min-width: 0;
    margin-inline-start: 0;
    padding-inline: 5px;
    gap: 3px;
    justify-content: flex-start;
  }

  .live-map-grid-status-chip-label,
  .live-map-planned-for-now-chip-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    flex: 0 1 auto;
  }

  .live-map-grid-status-chip-count,
  .live-map-planned-for-now-chip-count,
  .live-map-planned-for-now-chip-icon {
    flex-shrink: 0;
  }

  .live-map-planned-for-now-chip-icon {
    width: 12px;
    height: 12px;
  }

  @media (max-width: ${COMPACT_MOBILE_BREAKPOINT}) {
    .live-map-grid-status-chip-label,
    .live-map-planned-for-now-chip-label {
      display: none;
    }

    .live-map-planned-for-now-chip-icon {
      display: none;
    }

    [data-e2e="live-map-grid-status-chip"],
    [data-e2e="live-map-planned-for-now-chip"] {
      padding-inline: 5px;
      gap: 0;
      justify-content: center;
      min-width: 24px;
    }

    .live-map-grid-status-chip-count,
    .live-map-planned-for-now-chip-count {
      min-width: 1ch;
      text-align: center;
    }
  }
`;
